import { useTranslation } from 'react-i18next';
import { SEOMeta } from '../components/SEOMeta';
import { Section, Container, SectionTitle, Card } from "../components/ui";
import { FinalCTA } from "../components/sections/home";
import { RelatedPages } from '../components/RelatedPages';
import styles from "./About.module.css";

export function About() {
  const { t } = useTranslation('about');

  const founderQuote = t('founder.quote', { returnObjects: true }) as string[];
  const engagements = t('engagements.items', { returnObjects: true }) as { title: string; text: string }[];

  return (
    <>
      <SEOMeta title={t('meta.title')} description={t('meta.description')} />

      <Section variant="dark" className={styles.hero}>
        <Container>
          <div className={styles.heroContent}>
            <h1>{t('hero.title')}</h1>
            <p className={styles.heroSubtitle}>{t('hero.subtitle')}</p>
          </div>
        </Container>
      </Section>

      <Section variant="light">
        <Container>
          <div className={styles.founderSection}>
            <div className={styles.founderImage}>
              <img src="/images/founder-eric.webp" alt={t('founder.imageAlt')} width={600} height={450} loading="lazy" />
            </div>
            <blockquote className={styles.founderQuote}>
              {founderQuote.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
              <footer className={styles.quoteSignature}>
                {t('founder.signature')}
              </footer>
            </blockquote>
          </div>
        </Container>
      </Section>

      <Section variant="gray">
        <Container>
          <SectionTitle title={t('team.sectionTitle')} />
          <p className={styles.teamText}>{t('team.text')}</p>
          <div className={styles.teamImages}>
            <img src="/images/workshop-quality.webp" alt={t('team.workshopAlt')} className={styles.teamImg} width={1920} height={1048} loading="lazy" />
            <img src="/images/quality-heritage.webp" alt={t('team.qualityAlt')} className={styles.teamImg} width={600} height={450} loading="lazy" />
          </div>
        </Container>
      </Section>

      <Section variant="light">
        <Container>
          <SectionTitle title={t('engagements.sectionTitle')} centered />
          <div className={styles.engagementsGrid}>
            {engagements.map((engagement, i) => (
              <Card key={i} className={styles.engagementCard}>
                <h3 className={styles.engagementTitle}>{engagement.title}</h3>
                <p className={styles.engagementText}>{engagement.text}</p>
              </Card>
            ))}
          </div>
        </Container>
      </Section>

      <RelatedPages currentFrPath="/about" />
      <FinalCTA />
    </>
  );
}
